import { createContext } from "../createContext";

export type AuthContextValue = {
  customerId: string | null;
  logIn: (customerId: string, token: string) => void;
  logOut: () => void;
};

export const [useAuthContext, AuthContextProvider] = createContext<AuthContextValue>();
